import React from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import advancedFormat from "dayjs/plugin/advancedFormat";
import localizedFormat from "dayjs/plugin/localizedFormat";
import {
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/components/ui/tooltip";

dayjs.extend(relativeTime);
dayjs.extend(advancedFormat);
dayjs.extend(localizedFormat);

interface DateDisplayProps {
  datetime: string;
}

const DateDisplay: React.FC<DateDisplayProps> = ({ datetime }) => {
  const date = dayjs(datetime);
  const fromNow = date.fromNow();
  const fullDate = date.format("dddd, DD MMMM YYYY HH:mm");

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger>
          <span className="cursor-pointer">{fromNow}</span>
        </TooltipTrigger>
        <TooltipContent>
          <span>{fullDate}</span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default DateDisplay;
